<!--我的众筹.列表数据Item-->
<template>
  <div :mg-stat-custom="`cont=${item.id}&label=crowd&direct=web&addr=haowu_cfDet`" :mg-stat-lob="`crowd_id=${item.id}`"
       class="item-crowdfunding-mine" mg-stat-click
       @click="goCfDet()">
    <div class="item-crowdfunding-mine__wrapper">
      <div class="item-crowdfunding-mine__wrapper-icon">
        <span>{{ getIconContent() }}</span>
        <img v-lazy="item.originalImg"/>
      </div>
      <div class="item-crowdfunding-mine__wrapper-right">
        <p class="item-crowdfunding-mine__wrapper-right-title">
          <span class="item-crowdfunding-mine__wrapper-right-title-prefix">{{ item.tags }}</span>
          {{ item.name }}
        </p>
        <div class="item-crowdfunding-mine__wrapper-right-progressbar">
          <div class="item-crowdfunding-mine__wrapper-right-progressbar-runway"></div>
          <div :style="{width:getWithdPercent(item)+'%'}"
               class="item-crowdfunding-mine__wrapper-right-progressbar-percent"></div>
        </div>
        <div class="item-crowdfunding-mine__wrapper-right-progress">
          <span v-if="item.status === 1"
                class="item-crowdfunding-mine__wrapper-right-progress-num">{{ item.followNum || 0 }}人预约</span>
          <span v-else class="item-crowdfunding-mine__wrapper-right-progress-num">{{ item.joinNum || 0 }}人支持</span>
          <span class="item-crowdfunding-mine__wrapper-right-progress-percent">{{ getPercent(item) }}%</span>
        </div>

        <div class="item-crowdfunding-mine__wrapper-right-operation">
          <div v-if="item.lastLadder" class="item-crowdfunding-mine__wrapper-right-operation-price">
            <span class="item-crowdfunding-mine__wrapper-right-operation-price-prefix">￥</span>
            <span class="item-crowdfunding-mine__wrapper-right-operation-price-price">{{ item.lastLadder.price }}</span>
            <span class="item-crowdfunding-mine__wrapper-right-operation-price-suffix">起</span>
          </div>
          <div :class="['item-crowdfunding-mine__wrapper-right-operation-status',item.status===4?'endding':'']">
            {{ getBtnContent() }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'item-crowdfunding-mine',
  props: {
    item: {
      type: Object,
      default: {},
    },
    tabindex: Number, // 0,参与  1关注
  },
  methods: {
    getPercent(item) {
      const num = parseFloat(item.currentAmount);
      const total = parseFloat(item.targetAmount);
      if (isNaN(num) || isNaN(total)) {
        return '0';
      }
      return total <= 0 ? 0 : (Math.round(num / total * 10000) / 100.00);
    },
    getWithdPercent(item) {
      const percent = this.getPercent(item);
      return percent > 100 ? 100 : percent;
    },
    getIconContent() {
      const iconConent = {
        1: '预约中',
        2: '众筹中',
        3: '已结束',
        4: '已结束',
      };
      return iconConent[this.item.status];
    },
    getBtnContent() {
      const btnContent = {
        0: {// 参与
          1: '预约中', // 未开始肯定无法参与
          2: '查看项目',
          3: '查看项目', // 查看物流
          4: '已结束',
        },
        1: {// 关注
          1: '预约中',
          2: '去支持',
          3: '已结束',
          4: '已结束',
        },
      };
      return btnContent[this.tabindex][this.item.status];
    },
    goCfDet() {
      this.$router.push(`/cfDet?id=${this.item.id}`);
    },
    goTarget() {
      const url = '';
      const item = this.item;
      const status = item.status;
      const id = item.id;
      const targetUrl = {
        0: {// 参与
          1: `/cfDet?id=${id}`, //    "预约中",//未开始肯定无法参与
          2: `/cfDet?id=${id}`, // "查看项目",
          3: 'express?order_id=1&delivery_id=2', // "查看物流",
          4: `/cfDet?id=${id}`, // "已结束",
        },
        1: {// 关注
          1: `/cfDet?id=${id}`, // "预约中",
          2: `/cfDet?id=${id}`, // "去支持",
          3: `/cfDet?id=${id}`,
          4: `/cfDet?id=${id}`,
        },
      };
      this.$router.push(targetUrl[this.tabindex][status]);
    },
  },
};
</script>

<style lang="scss" scoped>
$right-content-width: 100%;

.item-crowdfunding-mine {
  width: 690px;
  background: white;
  border-radius: 20px;

  &__wrapper {
    padding: 30px 20px 40px 20px;
    display: flex;

    &-icon {
      position: relative;
      width: 166px;
      height: 166px;

      img {
        background: gray;
        width: 166px;
        height: 166px;
      }

      span {
        font-size: 22px;
        color: rgb(13, 13, 13);
        left: 10px;
        top: 10px;
        position: absolute;
        padding: 2px 5px 2px 5px;
        background: rgb(255, 255, 255);
        border-radius: 5px;
      }
    }

    &-right {
      margin-left: 21px;
      width: 500px;

      &-title {
        width: 100%;

        &-prefix {
          margin-right: 5px;
          border-radius: 8px;
          padding: 5px 8px 5px 8px;
          font-size: 24px;
          color: white;
          background: linear-gradient(180deg, rgb(255, 22, 30), rgb(255, 87, 40));
        }

        font-weight: bold;
        color: rgb(13, 13, 13);
        font-size: 26px;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }

      &-progressbar {
        position: relative;
        width: $right-content-width;
        top: 20px;

        &-runway {
          position: absolute;
          width: 100%;
          height: 12px;
          background: rgba(255, 236, 230, 1);
          border-radius: 6px;
        }

        &-percent {
          position: absolute;
          width: 20%;
          height: 12px;
          background: linear-gradient(-90deg, rgba(255, 25, 25, 1), rgba(255, 88, 30, 1));
          border-radius: 6px;
        }
      }

      &-progress {
        width: $right-content-width;
        margin-top: 32px;
        display: flex;

        &-num {
          flex: 1;
          font-size: 24px;
          font-weight: 400;
          color: rgba(168, 168, 168, 1);
          line-height: 50px;
        }

        &-percent {
          flex: 1;
          text-align: right;
          font-size: 24px;
          font-weight: 400;
          color: rgba(168, 168, 168, 1);
          line-height: 50px;
        }
      }

      &-operation {
        margin-top: 30px;
        display: flex;
        align-items: baseline;
        width: $right-content-width;

        &-price {
          flex: 1;
          display: flex;
          align-items: flex-end;

          &-prefix {
            font-size: 24px;
            font-weight: bold;
            color: rgba(255, 25, 25, 1);
            line-height: 50px;
          }

          &-price {
            font-size: 34px;
            font-weight: bold;
            color: rgba(255, 25, 25, 1);
            line-height: 50px;
          }

          &-suffix {
            margin-left: 5px;
            color: rgba(13, 13, 13, 1);
            line-height: 50px;
            font-size: 22px;
          }
        }

        &-status {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 60px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 25, 25, 1);
          border-radius: 30px;
          font-size: 28px;
          font-weight: 400;
          color: rgba(255, 25, 25, 1);
          line-height: 48px;
        }

        .endding {
          border-color: #A8A8A8;
          color: #A8A8A8;
        }
      }
    }

  }
}
</style>
